/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) New Icon component.
 */
export const NewIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height='16' viewBox='0 0 32 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width={iconSize} height='16' rx='3' fill={iconColor} />
      <path d='M10.7031 3.89062V11H9.23828L6.38184 6.23438V11H4.91699V3.89062H6.38184L9.24316 8.66113V3.89062H10.7031ZM17.748 9.85742V11H13.9639V9.85742H17.748ZM14.4424 3.89062V11H12.9775V3.89062H14.4424ZM17.2549 6.78613V7.89941H13.9639V6.78613H17.2549ZM17.7432 3.89062V5.03809H13.9639V3.89062H17.7432ZM21.3164 9.87207L22.7324 3.89062H23.5234L23.7041 4.88672L22.1953 11H21.3457L21.3164 9.87207ZM20.5889 3.89062L21.7607 9.87207L21.6631 11H20.7158L19.1387 3.89062H20.5889ZM24.9492 9.84766L26.1064 3.89062H27.5566L25.9844 11H25.0371L24.9492 9.84766ZM23.9678 3.89062L25.3936 9.89648L25.3545 11H24.5049L22.9863 4.88184L23.1816 3.89062H23.9678Z' fill='white' />
    </svg>
  );
};
